import { translateText } from '../services/napi';
import { TRANSLATE_TEXT_SUCCESS } from '../constant/actionType';

export function translate(text, key, title, onSuccess) {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const data = { key, text };
      const translatedText = await translateText(data, projectId);
      dispatch({
        data: translatedText.data.data,
        translatedField: title,
        translatedTo: key,
        type: TRANSLATE_TEXT_SUCCESS
      });
      onSuccess(translatedText.data.data, key, title);
    } catch (error) {
      console.error(error);
    }
  };
}
